export default function initHeatMap(stat) {
    let maxValue = 0;
    const data = stat.map(({name_en: name, iso_a3: code, count: value}) => {
        if (parseInt(value, 10) > maxValue) {
            maxValue = parseInt(value, 10);
        }
        return {
            name,
            code,
            value,
        };
    });
    const mapData = getMapData();
    return Highcharts.mapChart('heatMapPresenceCountryInRanking', {
        mapNavigation: {
            enabled: true,
            buttonOptions: {
                verticalAlign: 'bottom',
            },
        },
        title: {
            text: '',
        },
        colorAxis: {
            type: 'logarithmic',
            min: 1,
            max: maxValue,
            stops: [[0, '#F1EEF6'], [0.80, '#6842ff'], [1, '#6500ec']],
        },
        series: [{
            data,
            mapData,
            joinBy: ['iso-a3', 'code'],
            name: 'Количество образовательных организаций в рейтинге',
            borderWidth: 0.5,
        }],
        credits: {
            enabled: false,
        },
    });
}

function getMapData() {
    require('@highcharts/map-collection/custom/world-highres3.js');
    const mapCoordinates = Highcharts.maps['custom/world-highres3'];
    mapCoordinates.features.forEach((country) => {
        switch (country.id) {
            case 'UA':
                country.geometry.coordinates = [
                    [
                        [4900, 8046],
                        [4900, 8052],
                        [4905, 8056],
                        [4912, 8071],
                        [4921, 8068],
                        [4917, 8075],
                        [4915, 8089],
                        [4928, 8105],
                        [4947, 8122],
                        [4954, 8122],
                        [4958, 8127],
                        [4954, 8138],
                        [4959, 8140],
                        [4952, 8146],
                        [4944, 8158],
                        [4943, 8165],
                        [4948, 8170],
                        [4954, 8168],
                        [4966, 8180],
                        [4988, 8182],
                        [5007, 8182],
                        [5026, 8178],
                        [5039, 8174],
                        [5048, 8174],
                        [5051, 8168],
                        [5069, 8169],
                        [5075, 8167],
                        [5080, 8170],
                        [5082, 8166],
                        [5095, 8164],
                        [5104, 8170],
                        [5112, 8159],
                        [5121, 8164],
                        [5127, 8162],
                        [5136, 8164],
                        [5148, 8155],
                        [5151, 8160],
                        [5147, 8167],
                        [5151, 8177],
                        [5159, 8187],
                        [5175, 8189],
                        [5183, 8188],
                        [5187, 8186],
                        [5197, 8188],
                        [5201, 8197],
                        [5217, 8194],
                        [5225, 8199],
                        [5236, 8196],
                        [5244, 8198],
                        [5251, 8191],
                        [5252, 8182],
                        [5262, 8174],
                        [5252, 8171],
                        [5258, 8160],
                        [5255, 8155],
                        [5267, 8154],
                        [5269, 8152],
                        [5281, 8153],
                        [5293, 8132],
                        [5292, 8125],
                        [5298, 8120],
                        [5311, 8123],
                        [5316, 8117],
                        [5327, 8115],
                        [5335, 8120],
                        [5350, 8123],
                        [5355, 8114],
                        [5367, 8103],
                        [5372, 8109],
                        [5387, 8105],
                        [5395, 8099],
                        [5402, 8101],
                        [5404, 8097],
                        [5413, 8096],
                        [5420, 8089],
                        [5426, 8092],
                        [5430, 8078],
                        [5424, 8070],
                        [5417, 8069],
                        [5419, 8064],
                        [5426, 8064],
                        [5417, 8059],
                        [5415, 8053],
                        [5421, 8052],
                        [5425, 8040],
                        [5421, 8035],
                        [5419, 8024],
                        [5392, 8025],
                        [5389, 8019],
                        [5377, 8016],
                        [5373, 8005],
                        [5373, 7997],
                        [5355, 7997],
                        [5348, 7989],
                        [5344, 7991],
                        [5314, 7981],
                        [5305, 7981],
                        [5290, 7970],
                        [5285, 7971],
                        [5243, 7954],
                        [5229, 7961],
                        [5217, 7961],
                        [5221, 7957],
                        [5205, 7959],
                        [5183, 7965],
                        [5194, 7964],
                        [5185, 7969],
                        [5191, 7973],
                        [5178, 7977],
                        [5200, 7974],
                        [5202, 7977],
                        [5195, 7977],
                        [5189, 7986],
                        [5187, 7980],
                        [5166, 7980],
                        [5154, 7975],
                        [5155, 7973],
                        [5146, 7959],
                        [5126, 7942],
                        [5121, 7949],
                        [5120, 7937],
                        [5124, 7936],
                        [5122, 7928],
                        [5121, 7933],
                        [5112, 7936],
                        [5096, 7929],
                        [5082, 7932],
                        [5079, 7937],
                        [5087, 7939],
                        [5087, 7944],
                        [5101, 7957],
                        [5103, 7963],
                        [5101, 7973],
                        [5108, 7976],
                        [5108, 7970],
                        [5116, 7974],
                        [5120, 7970],
                        [5123, 7974],
                        [5126, 7969],
                        [5134, 7970],
                        [5129, 7976],
                        [5129, 7986],
                        [5119, 7991],
                        [5118, 8005],
                        [5114, 8004],
                        [5106, 8013],
                        [5109, 8026],
                        [5101, 8028],
                        [5096, 8035],
                        [5083, 8040],
                        [5075, 8040],
                        [5065, 8048],
                        [5058, 8048],
                        [5049, 8044],
                        [5038, 8045],
                        [5032, 8040],
                        [5023, 8039],
                        [5019, 8030],
                        [4992, 8027],
                        [4981, 8020],
                        [4974, 8027],
                        [4962, 8027],
                        [4948, 8030],
                        [4936, 8030],
                        [4930, 8034],
                        [4922, 8029],
                        [4918, 8035],
                        [4914, 8034],
                        [4900, 8046],
                    ],
                    [
                        [5135, 7970],
                        [5144, 7960],
                        [5146, 7962],
                        [5138, 7971],
                        [5135, 7970],
                    ],
                    [
                        [5255, 7967],
                        [5240, 7965],
                        [5249, 7957],
                        [5249, 7960],
                    ],
                ];
                break;
            case 'RU':
                country.geometry.coordinates.push([
                    [
                        [5273, 7963],
                        [5275, 7954],
                        [5289, 7934],
                        [5293, 7931],
                        [5312, 7937],
                        [5325, 7936],
                        [5321, 7928],
                        [5322, 7923],
                        [5315, 7920],
                        [5304, 7920],
                        [5296, 7924],
                        [5291, 7922],
                        [5281, 7913],
                        [5272, 7913],
                        [5263, 7910],
                        [5259, 7904],
                        [5248, 7898],
                        [5241, 7898],
                        [5231, 7905],
                        [5235, 7907],
                        [5238, 7918],
                        [5236, 7923],
                        [5228, 7926],
                        [5217, 7933],
                        [5206, 7932],
                        [5206, 7937],
                        [5216, 7943],
                    ],
                ]);
        }
    });
    const mapData = Highcharts.geojson(mapCoordinates);
    mapData.forEach((country) => {
        country.id = country.properties['hc-key'];
        country.flag = country.id.replace('UK', 'GB').toLowerCase();
    });
    return mapData;
}
